import React, { useState } from "react";
import { PaymentValidation} from "./noteContext";

const PaymentState = (props) => {
  const [paymentValidation,setPaymentValidation] = useState("hello");
  const [transaction,setTransaction] = useState(false);
  const value = {  paymentValidation, setPaymentValidation,transaction,setTransaction};
  return <PaymentValidation.Provider value={value}>{props.children}</PaymentValidation.Provider>;
};

export default PaymentState;